import {
  handleActions
} from 'redux-actions';
// import * as Header from '../actions/Header';

const initialState = {
  sign_in: false
}

const Reducer = handleActions({

}, initialState);

export default Reducer;


// WEBPACK FOOTER //
// ./src/reducers/Header.js